import { Icon, IconName } from '@ardoq/icons';
import { WithPopover } from '@ardoq/popovers';

export const DEFAULT_CHANGE_REQUEST_TOOLTIP = 'Some answers awaiting approval';

type ChangeRequestIconProps = {
  // Hover popover content + accessible label. Callers should pass a localized
  // string; this package does not have access to an I18nLocale.
  tooltip: string;
};

export const ChangeRequestIcon = ({ tooltip }: ChangeRequestIconProps) => (
  <WithPopover content={tooltip}>
    <Icon iconName={IconName.HISTORY} role="img" aria-label={tooltip} />
  </WithPopover>
);
